import {styled, Box, clsx} from 'external/material'
import {useState} from 'external/react'
import Group from './Group'
import useCatalog from 'hooks/catalog'
import { centerVertically } from 'utils/style'
import LessonLinks from './LessonLinks'
import UploadedLinks from './UploadedLinks'
import SectionLinks from './SectionLinks'
import useTranslations from 'hooks/translations'

import Message from 'components/Message'

const StyledEvent = styled(Box)(eventStyles)

export default function Event (props) {
  const [[openMessage, anchorEl], setOpenMessage] = useState([false, null])
  const {type, group, content} = props
  const {subjects = {}, isDownloaded} = useCatalog()
  const subjectId = group.course.substring(0,2)
  const subject = subjects[subjectId]
  const downloaded = isDownloaded({id: props.title, hash: props.hash})

  const date = props.date().toDate()

  const {formatDate} = useTranslations()

  const getMessage = () => {
    const isUploaded = !!content.url
    const lesson = isUploaded
      ? content.title
      : props.title
    const title = isUploaded 
      ? content.title
      : content.name
    const text = type == 'quiz'
      ? content.comments
      : type == 'homework'
        ? content.instructions
        : content.message
    return {date: formatDate(date), lesson, title, text}
  }

  function handleMessageClick (e) {
    setOpenMessage([true, e.target])
  }

  const message = openMessage ? getMessage() : {}

  return (
    <StyledEvent className="schedule-event">
      <Message open={openMessage} anchorEl={anchorEl} {...message} onClose={() => setOpenMessage([false, null])} />
      {subject && (<Group {...{group, type, subject}} />)}
      <div className="content">
        {eventContent(props)}
      </div>
      <div className="actions-wrapper">
        <div className="actions">
          {type == 'schedule' && (<LessonLinks onMessageClick={e => setOpenMessage([true, e.target])} {...props} downloaded={downloaded} />)}
          {type == 'uploaded' && (<UploadedLinks onMessageClick={e => setOpenMessage([true, e.target])} {...props} downloaded={downloaded} />)}
          {(type == 'quiz' || type == 'homework') && (<SectionLinks onMessageClick={e => setOpenMessage([true, e.target])} {...props} />)}
        </div>
      </div>
    </StyledEvent>
  )
}
  


function eventContent({type, content, title, lessonName}) {
  switch (type) {
    case 'comment': return content.message
    case 'uploaded': return content.title
    case 'a.assignment': return content.title
    case 'schedule': return `${title} - ${lessonName}`
    default: return title
  }
}

function eventStyles(){
  return {
   "&.schedule-event": {
      display: 'flex',
      flexShrink: 0,
      minHeight: '90px',
      "& .content": {
        flexGrow: 1,
        ...centerVertically,
        borderBottom: 'solid 1px #e1eaee',
        paddingTop: 10,
        paddingBottom: 10,
      },
      "& .actions-wrapper": {
        ...centerVertically,
        borderBottom: 'solid 1px #e1eaee',
        paddingRight: 5,
        "& .actions": { 
          display: 'flex',
          "& .link": {
            cursor: 'pointer',
            width: '80px',
            textAlign: 'center',
            marginRight: '15px',
            borderRadius: '5px',
            padding: '4px 0',
            "&:hover": { 
              transform: 'scale(1.04)'
            }
          }
        }
     }
    }
  }
}
